import { render, staticRenderFns } from "./contadoresFormulario.vue?vue&type=template&id=b00108f2&"
import script from "./contadoresFormulario.vue?vue&type=script&lang=ts&"
export * from "./contadoresFormulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports